import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { typeViewBy } from '../../constant'
import EachYear from './EachYear'
import Table from './Table'
import { selectLoading } from './store/slice'
import Trend from './trend'

export const daysSaleKey = {
  VALUE: 'RT0009',
  VALUE_AVG: 'RTI0009',
}

export const daysInventoryKey = {
  VALUE: 'RT0011',
  VALUE_AVG: 'RTI0011',
}

export const daysPayableKey = {
  VALUE: 'RT0013',
  VALUE_AVG: 'RTI0013',
}

export const daysConversionKey = {
  VALUE: 'RT0015',
  VALUE_AVG: 'RTI0015',
}

const AssetManagementEfficiency = ({ viewBy, id, isDownloadComponent }) => {
  const loading = useSelector(selectLoading)

  return (
    <Element className="h100" style={{ color: '#3A414B' }}>
      {loading ? (
        <Loading />
      ) : viewBy === typeViewBy.TREND ? (
        <Trend isDownloadComponent={isDownloadComponent} id={id} />
      ) : viewBy === typeViewBy.EACH_YEAR ? (
        <EachYear id={id} isDownloadComponent={isDownloadComponent} />
      ) : (
        <Table id={id} />
      )}
    </Element>
  )
}

export default AssetManagementEfficiency
